module.exports = __webpack_public_path__ + "img/il-gallery-unauthorised.a8a707f.svg";